import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Echolink. All rights reserved.</p>
            </div>
            <div className="footer-links">
                <Link to="/" className="footer-link">Home</Link>
                <Link to="/terms" className="footer-link">Terms of Service</Link>
            </div>
        </footer>
    );
};

export default Footer;
